import { render, staticRenderFns } from "./CourseDownloadButton.vue?vue&type=template&id=deed6c3e"
import script from "./CourseDownloadButton.vue?vue&type=script&lang=js"
export * from "./CourseDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports